import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const comparisonKey = (interviewId, userIds) =>
  `${interviewId}_${[...(userIds || [])].sort().join("-")}`;

const recommendCandidate = createAsyncThunk(
  "recommendCandidate",
  async ({ interviewId, userIds }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/candidate-comparison/recommend`,
        { interviewId, userIds }
      );
      if (data.success) {
        return { key: comparisonKey(interviewId, userIds), data: data.data };
      }
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export { recommendCandidate, comparisonKey };
